import {IArtifactFlat} from "./export-flat";
import {exportArtifactList, generateXlsx, prepareArtifactForXlsExport} from "./exportCustomXlsx";

import JSZip from 'jszip';
import { saveAs } from 'file-saver';
import {generateDocx, generateMultipleArtifactsDoc} from "./exportDocx";
import {Packer} from "docx";

export async function exportZip(artifact: IArtifactFlat): Promise<any> {
    const zip = new JSZip();
    const baseName = artifact.title?.replace(/\s+/g, '_') || 'artifact';
    const zipName = `${baseName}.zip`;

    const docx = generateDocx(artifact);
    const docBlob = await Packer.toBlob(await docx);
    zip.file(`${baseName}.docx`, docBlob);

    const dataXlsx = prepareArtifactForXlsExport(artifact);
    const xlsx = generateXlsx(dataXlsx.rows, dataXlsx.options);
    zip.file(`${baseName}.xlsx`, xlsx);

    const zipBlob = await zip.generateAsync({ type: 'blob' });
    saveAs(zipBlob, zipName);
}

export async function exportZipForList(artifacts: IArtifactFlat[], fileName: string): Promise<any> {
    const zip = new JSZip();
    const baseName = fileName.replace(/\s+/g, '_') || 'artifact';
    const zipName = `${baseName}.zip`;

    const docx = generateMultipleArtifactsDoc(artifacts);
    const docBlob = await Packer.toBlob(await docx);
    zip.file(`${baseName}.docx`, docBlob);

    const dataXlsx = exportArtifactList(artifacts, fileName);
    const xlsx = generateXlsx(dataXlsx.rows, dataXlsx.options);
    zip.file(`${baseName}.xlsx`, xlsx);

    const zipBlob = await zip.generateAsync({ type: 'blob' });
    saveAs(zipBlob, zipName);
}
